<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { format } from 'svelte-i18n';
	//Design system components
	import { TemperatureWheel } from '@Shelly/shelly-design-system';

	export let value = 19,
		units = 'C';

	export let min = 4;
	export let max = 30;
	export let disabled = false;

	// Case for TRV-Gen 1, where step and btnStep are the same value (0.5)
	// Case for BLE-TRV, where step is 0.5 and btnStep is 0.1
	// https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/1934
	export let step = 0.5;
	export let btnStep = 0.5;

	if (units === 'F') {
		min = 40;
		max = 87;
	}

	/* time stuff */
	let timer;
	let interval;
	let long = false;

	const dispatch = createEventDispatcher();

	const set_time = (delay) => {
		clearTimeout(timer);
		timer = 0;
		timer = setTimeout(() => {
			long = false;
		}, delay);
	};

	const reset_hide_timeout = () => {
		long = true;
		set_time(2200);
	};

	const handle_temp_adj = (e) => {
		let value = Number(e?.detail?.value);
		reset_hide_timeout();
		dispatch('change', { value, units });
	};

	const a11yProps = {
		tempWheelAriaLabel: $format('label_temperature', { default: 'Temperature' }),
		thumbAriaLabel: $format('label_temperature_thumb', { default: 'Temperature thumb' }),
		incrementBtnAriaLabel: $format('button_increase_temperature', {
			default: 'Increase temperature',
		}),
		decrementBtnAriaLabel: $format('button_decrease_temperature', {
			default: 'Decrease temperature',
		}),
		spinnerAriaLabel: $format('label_spinner', { default: 'Spinner' }),
	};
</script>

<TemperatureWheel
	{a11yProps}
	{disabled}
	valuePrefix={'°' + units}
	{value}
	{min}
	{max}
	{btnStep}
	{step}
	on:value_change={(e) => handle_temp_adj(e)}
	type={'temp'}
/>
